import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { AccidentFeatureConfig } from '../../../types/insurances/AccidentFeatureConfig';
import { accident as base } from './base';
import { accident as AT } from './AT';
import { accident as HR } from './HR';
import { accident as HU } from './HU';
import { accident as RO } from './RO';

export const accidentConfig: InsuranceIndex<AccidentFeatureConfig> = { base, AT, HR, HU, RO };
